@if (displayError) {
  <app-error></app-error>
} @else {
  <main>
    <div class="mx-12 px-6 py-12 text-black sm:mx-16 lg:mx-24 lg:px-8">
      <section class="text-gray-600 body-font">
        <div class="mb-10 hidden rounded-2xl border border-neutral-200 bg-white px-6 py-5 sm:px-10 sm:py-6 lg:block">
        <nav aria-label="Tipos de ocorrência" class="flex flex-wrap items-end justify-center gap-x-4 gap-y-2 sm:gap-x-10">
          @for (type of types; track type.padrao) {
            <a routerLink="/ocorrencias" [queryParams]="{padrao: type.padrao}"
               [attr.aria-current]="category === type.code ? 'true' : null"
               [ngClass]="category === type.code
                 ? 'inline-flex items-center gap-3 border-b-2 border-neutral-900 px-4 py-3 text-sm font-semibold text-neutral-900'
                 : 'inline-flex items-center gap-3 border-b-2 border-transparent px-4 py-3 text-sm font-medium text-neutral-600 hover:border-neutral-300 hover:text-neutral-900'">
              <img [src]="'assets/img/' + type.image" alt="" class="h-10 w-10 object-contain">
              <span>{{ type.label }}</span>
            </a>
          }
        </nav>
        </div>
        <h2 class="text-2xl font-bold tracking-wide text-gray-900 mb-4">Foram encontradas
          <span>({{pagination?.totalElements?? '0'}})</span> ocorrências.
        </h2>
        <div class="mt-10 flex flex-col gap-8 lg:flex-row lg:items-start">
          <div class="w-full shrink-0 lg:w-[19rem]">
            <app-filterevent #eventFilter [category]="category" (filters)="fetchEvents($event)" (categorySelected)="onCategorySelected($event)"></app-filterevent>
          </div>
          <div class="min-w-0 flex-1">
            <app-listevent [eventPage]="this.eventResponse" (changePageEvent)="changePageEvent($event)"></app-listevent>
          </div>
        </div>
      </section>
    </div>
  </main>
}

